import * as React from 'react';
import classnames from 'classnames';
import { ICoreContext, Image, IImageSettings } from '@msdyn365-commerce/core';

interface IDiscountBadgeProps {
    context: ICoreContext;
    className?: string;
    badge: string | undefined;
    size: 'small' | 'medium' | 'large' | 'x-large';
    sizeMultiplier?: number;
    allowZoomIn?: boolean;
}

function getDiscountBadgeSize(size: 'small' | 'medium' | 'large' | 'x-large', sizeMultiplier: number): { w: number, h: number } {
    switch (size) {
        case 'small':
            return { w: 48 * sizeMultiplier, h: 48 * sizeMultiplier };
        case 'medium':
            return { w: 56 * sizeMultiplier, h: 56 * sizeMultiplier };
        case 'large':
            return { w: 72 * sizeMultiplier, h: 72 * sizeMultiplier };
        case 'x-large':
        default:
            return { w: 72 * sizeMultiplier, h: 72 * sizeMultiplier };
    }
}

function getImageSettings(size: 'small' | 'medium' | 'large' | 'x-large', sizeMultiplier: number): IImageSettings {
    const { w, h } = getDiscountBadgeSize(size, sizeMultiplier);

    return {
        viewports: {
            xs: { w, h, q: `w=${w}&h=${h}&q=80&m=0&f=png` },
            lg: { w, h, q: `w=${w}&h=${h}&q=80&m=0&f=png` },
            xl: { w, h, q: `w=${w}&h=${h}&q=80&m=0&f=png` }
        },
        quality: 80
    };
}

const DiscountBadge = (props: IDiscountBadgeProps) => {
    const baseClassName = 'dlvry-discount-badge';

    if (!props.badge) {
        return null;
    }

    let baseImageUrl = props.context.request.apiSettings.baseImageUrl;

    if (baseImageUrl.endsWith('/')) {
        baseImageUrl = baseImageUrl.slice(0, -1);
    }

    return (
        <div className={classnames(baseClassName, props.className, props.size, { 'zoom-in': props.allowZoomIn })}>
            <Image
                requestContext={props.context.request}
                src={baseImageUrl + props.badge}
                gridSettings={props.context.request.gridSettings!}
                imageSettings={getImageSettings(props.size, props.sizeMultiplier || 1)}
                loadFailureBehavior='empty'
            />
        </div>
    );
};

export default DiscountBadge;
